import { BaseEntityService } from "../BaseEntityService"
import { RoleODataRepo, RoleRepo } from "../../data/repo";
import { RoleModel } from "../../data/entities";

export class RoleService extends BaseEntityService<RoleModel, RoleRepo, RoleODataRepo> {
  constructor(){
    super(new RoleRepo(), new RoleODataRepo());
  }
}

export default RoleService;
